import { render, staticRenderFns } from "./EditorDialog.vue?vue&type=template&id=b78306d6&"
import script from "./EditorDialog.vue?vue&type=script&lang=js&"
export * from "./EditorDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditorDialog.vue?vue&type=style&index=0&id=b78306d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports